import { createFromIconfontCN } from "@ant-design/icons";
import React from "react";

/** 更新后替换地址即可 */
const iconfontUrl = "//at.alicdn.com/t/font_3383315_flpg7zv41r.js";

const IconFont = createFromIconfontCN({
  scriptUrl: iconfontUrl,
});

export interface IIconProps {
  type: string;
  className?: string;
  onClick?: () => void;
  /** 旋转角度 */
  rotate?: number;
}

/**
 *
 *
 * @description 详细参考 https://addcn.yuque.com/docs/share/a9e922b0-7c52-4ce4-95ad-8af777ba19fb?# 《引入iconfont解决icon图片资源问题》
 */
const Icon: React.FC<IIconProps> = (props: IIconProps) => {
  const { type, className, onClick, rotate } = props;
  return (
    <IconFont
      type={type}
      rotate={rotate}
      className={className}
      onClick={onClick}
    />
  );
};

export default Icon;
